import { LanguageOption } from '../../models/cube/language-option.type';
import { AppState } from '../state/app.state';
import { SystemState } from '../state/system.state';

import { createSelector } from '@ngrx/store';

const systemState = (state: AppState): SystemState => state.system;
export const selectCurrentLang = createSelector(
  systemState,
  (state: SystemState): LanguageOption => state.currentLang
);
